<template>
  <SysDialog
    v-model="MODAL_ATIVO_COMPUTED"
    largura="600"
    content-class="bra-5"
    ocultar-acoes
    :style="{height: alturaDoModal + 'px' }"
  >
    <template #titulo>
      <div class="d-flex justify-space-between w-full mb-2 fixed">
        <div><span>Justificativas de Transferência</span></div>

        <v-btn icon @click="voltar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </template>

    <v-form ref="form" v-model="formValido" lazy-validation>
      <div class="d-flex mb-6 gap-8">
        <div
          class="pill-btn"
          :class="{ 'pill-btn--primary': form.escopo === 'carrinho' }"
          @click="form.escopo = 'carrinho'"
        >
          Aplicar ao Carrinho
        </div>

        <div
          class="pill-btn"
          :class="{ 'pill-btn--primary': form.escopo === 'todos-itens' }"
          @click="form.escopo = 'todos-itens'"
        >
          Aplicar a Todos os Itens
        </div>

        <div
          class="pill-btn pill-with-pin"
          :class="{
              'pill-btn--primary': form.escopo === 'itens-selecionados',
              'pill-btn--disabled': selecionados.length <= 0
          }"
          @click="form.escopo = 'itens-selecionados'"
        >
          Aplicar aos Itens Selecionados

          <span class="pin">
            {{ selecionados.length }}
          </span>
        </div>
      </div>

      <v-row>
        <v-col cols="12" sm="12">
          <div style="color: #4B4B53;" class="d-flex justify-space-between font-14 mb-2 font-weight-regular">
            Selecione a justificativa
          </div>

          <SelecaoTipoJustificativa
            v-model="form.tipo_justificativa"
            required
          />
        </v-col>

        <v-col cols="12">
          <v-divider class="mt-n4 mb-3" />

          <div style="color: #4B4B53;" class="d-flex justify-space-between font-14 mb-2 font-weight-regular">
            Descreva a justificativa
          </div>

          <v-textarea
            v-model="form.justificativa"
            rows="4"
            auto-grow
            outlined
            hide-details="false"
            placeholder="Insira aqui a justificativa da transferência..."
            class="bra-8"
            :error-messages="justificativaErrors"
            @input="$v.form.justificativa.$touch()"
            @blur="$v.form.justificativa.$touch()"
            maxLength="250"
          />

          <div style="display: flex; justify-content: space-between">
            <template v-if="justificativaErrors">
              <p style="font-size: 12px" class="error--text mb-n1">{{ justificativaErrors[0] }}</p>
            </template>

            <div v-if="form.justificativa">
              <span style="font-size: 12px">Caracteres: <strong>{{ form.justificativa.length }}/250 </strong></span>
            </div>
          </div>
        </v-col>

        <v-col cols="12">
          <v-divider class="mt-n4 mb-3" />

          <div style="color: #19191C;" class="d-flex justify-space-between font-14 mb-2 font-weight-medium">
            Histórico de Justificativas
          </div>

          <div class="d-flex mb-6 gap-8">
            <div
              class="pill-btn"
              :class="{ 'pill-btn--secondary': historico_preview_tipo === 'carrinho' }"
              @click="historico_preview_tipo = 'carrinho'"
            >
              Carrinho
            </div>

            <div
              class="pill-btn"
              :class="{ 'pill-btn--secondary': historico_preview_tipo === 'todos-itens' }"
              @click="historico_preview_tipo = 'todos-itens'"
            >
              Itens
            </div>
          </div>

          <div class="history-wrap">
            <div
              v-if="HISTORICO_PREVIEW_COMPUTED.length <= 0"
              class="d-flex justify-center"
            >
              <span class="text-center font-italic">
                Nenhuma justificativa registrada até o momento.
              </span>
            </div>

            <table v-else class="history-table">
              <thead>
              <tr>
                <th>Data/Hora</th>
                <th>Usuário</th>
                <th>Justificativa</th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="h in HISTORICO_PREVIEW_COMPUTED" :key="h.id">
                <td class="col-date">{{ moment(h.data_justificativa, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm') }}</td>
                <td class="col-user">{{ h.nome_usuario }}</td>
                <td class="col-just">
                    <span v-if="!h.justificativa || h.justificativa.length <= 25">
                      {{ h.justificativa }}
                    </span>

                  <Legenda v-else titulo="Legenda" :legenda="h.justificativa">
                    {{ h.justificativa.slice(0, 25) }}…
                  </Legenda>
                </td>
              </tr>
              </tbody>
            </table>

            <v-divider class="my-4" />

            <div class="d-flex justify-end">
              <div class="pill-link pill-with-pin" @click="dialog_historico = true">
                Mostrar Todas

                <span class="pin">
                  {{ historico_justificativas.length }}
                </span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <div class="d-flex justify-end mt-3 mb-5">
        <v-btn
          color="#013254"
          class="vbtn-class bra-7 w-20-porcento"
          height="35"
          outlined
          @click="voltar"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="#013254"
          class="white--text text-none bra-7 w-40-porcento"
          height="35"
          :loading="loading"
          :disabled="DISABLED_SALVAR_COMPUTED"
          @click="salvar"
        >
          Salvar Justificativa
        </v-btn>
      </div>
    </v-form>

    <SysDialog
      v-model="dialog_historico"
      titulo=""
      content-class="bra-5"
      ocultar-acoes
      :largura="450"
    >
      <template #titulo>
        <div class="d-flex justify-space-between w-full mb-2 fixed">
          <div></div>

          <v-btn icon @click="dialog_historico = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </template>

      <div class="history-list">
        <div v-for="(h, index) in historico_justificativas" :key="h.id">
          <div class="d-flex flex-column">
            <span class="text-gray-300 font-13">
              {{ moment(h.data_justificativa, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm') }} • {{ h.nome_usuario }}
            </span>
            <span class="mt-n1 mb-1 font-12">{{ h.tipo_justificativa }} • {{ formatarEscopoJustificativa(h.escopo) }}</span>
            <span class="mt-n1 font-14 text-black">{{ h.justificativa }}</span>
          </div>

          <v-divider class="my-4" />
        </div>
      </div>
    </SysDialog>
  </SysDialog>
</template>

<script>
import SelecaoTipoJustificativa
  from "@/components/drp/separacaoDeMercadorias/Carrinho/SelecaoTipoJustificativa/Index.vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import moment from "moment/moment";
import api from "@/api/api";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import {pedidos_mixin} from "@/components/compra/ProdutosGerais/Carrinho/PedidosMixin";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";

const minTrimmedLength = (min) =>
  helpers.withParams({ type: "minTrimmedLength", min }, (value) =>
    String(value ? value : "").trim().length >= min
  );

export default {
  name: "DialogJustificativasCarrinhoSeparacao",
  components: { Legenda, SelecaoTipoJustificativa, SysDialog },
  props: {
    value: { type: Boolean, required: true },
    idpedido: { type: Number, required: true },
    selecionados: { type: Array, required: false },
    inicial: {
      type: Object,
      default: () => ({
        escopo: 'carrinho',
        tipo_justificativa: null,
        justificativa: ''
      }),
    },
  },
  mixins: [ResponsiveHeight],
  data() {
    return {
      loading: false,
      formValido: false,
      form: {
        escopo: this.selecionados.length >= 2 ? 'itens-selecionados' : this.inicial.escopo,
        tipo_justificativa: this.inicial.tipo_justificativa,
        justificativa: this.inicial.justificativa,
      },
      historico_justificativas: [],
      historico_preview_tipo: 'carrinho',
      rules: {
        required: (v) => !!(v && String(v).trim()) || "Campo obrigatório",
        min: v => {
          const s = (v ? v : "").toString().trim()
          return s.length >= 10 || "Mínimo de 10 caracteres"
        },
        max: v => {
          const s = (v ? v : "").toString().trim()
          return s.length <= 250 || "Máximo de 250 caracteres"
        }
      },
      dialog_historico: false,
    };
  },
  validations: {
    form: {
      justificativa: {
        required,
        minTrimmedLength: minTrimmedLength(10),
        maxLength: maxLength(250),
      }
    }
  },
  mounted() {
    this.buscarHistoricoJustificativas();
  },
  computed: {
    moment() {
      return moment
    },
    MODAL_ATIVO_COMPUTED: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    HISTORICO_PREVIEW_COMPUTED() {
      return this.historico_justificativas
      .filter((i) => i.escopo === this.historico_preview_tipo)
      .slice(0, 2);
    },
    DISABLED_SALVAR_COMPUTED() {
      return (
        this.form.tipo_justificativa === null ||
        this.$v.form.justificativa.$invalid
      );
    },
    justificativaErrors() {
      const errors = [];
      if (!this.$v.form.justificativa.$dirty) return errors;
      !this.$v.form.justificativa.required && errors.push("Campo Obrigatório.");
      !this.$v.form.justificativa.minTrimmedLength && errors.push("Mínimo de 10 caracteres");
      !this.$v.form.justificativa.maxLength && errors.push("Máximo de 250 caracteres");
      return errors;
    },
    alturaDoModal() {
      return this.alturaDaJanela - 150;
    }
  },
  methods: {
    voltar() {
      this.MODAL_ATIVO_COMPUTED = false;
      this.$v.$reset();
    },
    async salvar() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const ok = await this.$refs.form.validate();
      if (!ok) return;

      const produtos = this.selecionados.map(s => ({
        idpedido: s.idpedido,
        filial_origem: s.filial_origem,
        filial_destino: s.filial_destino,
        idproduto: s.idproduto
      }));

      const body = {
        idpedido: this.idpedido,
        escopo: this.form.escopo,
        tipo_justificativa: this.form.tipo_justificativa,
        justificativa: this.form.justificativa,
        produtos
      }

      api.post('drp-grupo/cadastrar-justificativa-separacao-mercadoria', body)
      .then(() => {
        this.$emit("upload:concluido");
        this.buscarHistoricoJustificativas();

        alert('Justificativa registrada com sucesso.');
        this.$refs.form.resetValidation();
        this.$v.$reset();
      }).catch(() => {
        alert('Falha ao cadastrar justificativa.');
      });

      this.MODAL_ATIVO_COMPUTED = false;
    },
    buscarHistoricoJustificativas() {
      api.get('drp-grupo/buscar-justificativas-carrinho')
      .then((response) => {
        this.historico_justificativas = response.data.justificativas;
      }).catch((error) => {
        alert(error);
      });
    },
    formatarEscopoJustificativa(slug) {
      return String(slug)
      .trim()
      .replace(/[-_]+/g, " ")
      .toLowerCase()
      .replace(/\b\p{L}/gu, (c) => c.toUpperCase());
    }
  },
  watch: {
    value(v) {

      if (v) {
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.resetValidation();
          this.form = { ...this.inicial };
        });
      }
    },
  },
};
</script>

<style scoped>
.vbtn-class {
  text-transform: none;
  border: 1px solid #DFDFE0;
  padding: 10px 25px 10px 20px;
  margin-top: 1px;
  margin-right: 15px;
  font-weight: 500;
}

.vbtn-class {
  text-transform: none;
  border: 1px solid #DFDFE0;
  padding: 10px 25px 10px 20px;
  margin-top: 1px;
  margin-right: 15px;
  font-weight: 500;
}

.gap-8 {
  gap: 8px;
}

.pill-btn {
  border: 1px solid #DFDFE0;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 13px;
  color: #19191C;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  background: #fff;
  display: inline-flex;
  align-items: center;
}

.pill-btn:hover {
  background-color: #DFDFE0;
}

.pill-btn--secondary:hover {
  background-color: #04385d;
}

.pill-btn--primary {
  border-color: #2F80ED;
  box-shadow: 0 0 0 1px rgba(47, 128, 237, 0.15) inset;
}

.pill-btn--disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: .5;
}

.pill-btn--secondary {
  background-color: #013254;
  border-color: #013254;
  box-shadow: 0 0 0 1px rgba(47, 128, 237, 0.15) inset;
  color: #FFFFFF;
}

.history-list {
  margin-top: -30px;
  max-height: 550px;
  overflow-y: auto;
  padding: 10px 12px;
}

.history-wrap {
  width: 100%;
}

.history-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.history-table thead th {
  text-align: left;
  font-size: 12px;
  color: #6B7280;
  font-weight: 600;
}

.history-table tbody td {
  padding: 10px 0;
  vertical-align: top;
  font-size: 13px;
  color: #19191C;
}

.col-date {
  width: 100px;
  white-space: nowrap;
}

.col-user {
  width: 70px;
  word-break: break-word;
}

.pill-link {
  border: 1px solid #DFDFE0;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
  color: #19191C;
  background: #fff;
}

.pill-link:hover {
  background-color: #DFDFE0;
}

.pill-with-pin {
  position: relative;
}

.pill-with-pin .pin {
  position: absolute;
  top: -8px;
  right: -8px;

  min-width: 18px;
  height: 19px;
  padding: 0 6px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: 11px;
  line-height: 18px;
  border-radius: 999px;

  background: #ff5252;
  color: #fff;
  border: 2px solid #fff;
}
</style>
